module.exports = __webpack_public_path__ + "static/media/Tryunfo.d351afec.mp4";